/* Counts Shopify-accepted enquiries, not submit-button clicks. No field values are collected. */
(() => {
  'use strict';
  if (window.Shopify?.designMode || window.Shopify?.theme?.role !== 'main' ||
      new URLSearchParams(location.search).has('preview_theme_id')) return;
  const ttl = 30 * 60 * 1000;
  const prefix = 'co2-enquiry:';
  const read = key => { try { return JSON.parse(sessionStorage.getItem(key)); } catch (_) { return null; } };
  const write = (key, value) => { try { sessionStorage.setItem(key, JSON.stringify(value)); } catch (_) {} };
  const remove = key => { try { sessionStorage.removeItem(key); } catch (_) {} };
  const originKey = 'co2-enquiry-origin';
  const resourceSources = new Set([
    '/pages/carbon-credits', '/pages/what-is-a-carbon-credit',
    '/pages/how-to-buy-carbon-credits', '/pages/high-integrity-carbon-credits',
    '/pages/carbon-credit-standards-integrity', '/pages/ccp-carbon-credits',
    '/pages/safe-water-carbon-credits', '/pages/cookstove-carbon-credits',
    '/pages/how-to-calculate-travel-carbon-emissions',
    '/pages/how-flight-carbon-emissions-are-calculated'
  ]);
  const validOrigin = source => source === '/pages/bristol' || resourceSources.has(source);
  const enquiryOrigin = () => {
    const origin = read(originKey);
    if (validOrigin(origin?.source) && origin.destination === location.pathname &&
        Date.now() - origin.started >= 0 && Date.now() - origin.started < ttl) return origin.source;
    return null;
  };
  const originProps = origin => validOrigin(origin) ? { enquiry_origin: origin } : {};
  const emit = (name, props) => { try { window.plausible?.(name, { props }); } catch (_) {} };
  document.querySelectorAll('[data-co2-enquiry]').forEach(marker => {
    const form = marker.closest('form');
    if (!form) return;
    const kind = marker.dataset.co2Enquiry;
    const key = prefix + location.pathname + ':' + form.id + ':' + kind;
    const pending = read(key);
    if (marker.dataset.co2Status === 'success' && pending?.submitted &&
        Date.now() - pending.submitted >= 0 && Date.now() - pending.submitted < ttl) {
      remove(key); // Consume before sending: refresh/back must not count another enquiry.
      emit('Enquiry Submitted', { enquiry_type: kind, ...originProps(pending.enquiry_origin) });
      if (pending.enquiry_origin === enquiryOrigin()) remove(originKey);
    } else if (pending?.submitted && (marker.dataset.co2Status === 'error' || Date.now() - pending.submitted >= ttl)) {
      remove(key);
    }
    let started = false;
    const start = event => {
      if (started || !event.isTrusted) return;
      started = true;
      emit('Enquiry Started', { enquiry_type: kind, ...originProps(enquiryOrigin()) });
    };
    form.addEventListener('input', start);
    form.addEventListener('change', start);
    form.addEventListener('submit', event => {
      // Native validation precedes submit. Do not interfere with CAPTCHA or Shopify submission.
      if (!event.isTrusted || event.defaultPrevented) return;
      write(key, { submitted: Date.now(), ...originProps(enquiryOrigin()) });
    });
  });
  document.addEventListener('click', event => {
    if (!event.isTrusted) return;
    const link = event.target.closest('a[href]');
    if (!link) return;
    const href = link.getAttribute('href');
    const bristolLink = location.pathname === '/pages/bristol' && link.dataset.co2EnquiryOrigin === 'bristol';
    const resourceLink = resourceSources.has(location.pathname) && link.dataset.co2EnquiryOrigin === 'resource';
    if (bristolLink || resourceLink) {
      const destination = new URL(href, location.href);
      const allowedDestination = resourceLink ? destination.pathname === '/pages/carbon-credits-for-businesses' : [
        '/pages/contact', '/pages/carbon-credits-for-businesses',
        '/pages/carbon-management', '/pages/develop-a-project-1'
      ].includes(destination.pathname);
      if (destination.origin === location.origin && allowedDestination && !destination.searchParams.has('view')) {
        write(originKey, { source: location.pathname, destination: destination.pathname, started: Date.now() });
      }
    }
    if (/^mailto:/i.test(href)) emit('Email Click', {});
    else if (/^tel:/i.test(href)) emit('Phone Click', {});
    else if (/\/CO2balance_Biochar_Feasibility_Questionnaire_Download\.docx(?:\?|$)/i.test(href)) {
      emit('Questionnaire Download', { questionnaire: 'Biochar feasibility' });
    }
  });
})();
